'use client';

import { useEffect, useState } from 'react';

export function SlideshowWidget({ photos }: { photos: string[] }) {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % photos.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [photos.length]);

  const prev = () => setCurrent(c => (c - 1 + photos.length) % photos.length);
  const next = () => setCurrent(c => (c + 1) % photos.length);

  return (
    <div className="slideshow-container">
      {photos.map((src, i) => (
        <img
          key={src}
          src={src}
          alt={`704 Collective photo ${i + 1}`}
          className={`slide-img${i === current ? ' active' : ''}`}
        />
      ))}
      <button className="slideshow-arrow prev" onClick={prev} aria-label="Previous photo">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <button className="slideshow-arrow next" onClick={next} aria-label="Next photo">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6"/></svg>
      </button>
      <div className="slideshow-dots">
        {photos.map((_, i) => (
          <button
            key={i}
            className={`slideshow-dot${i === current ? ' active' : ''}`}
            onClick={() => setCurrent(i)}
            aria-label={`Go to photo ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
